import * as moment from 'moment'

export type InitTransaction = {
  id: string
  type: 'INIT'
  createdOn: moment.Moment
  description?: string
  amount: number
  interest: number
}

export type CloseTransaction = {
  id: string
  type: 'CLOSE'
  createdOn: moment.Moment
  description?: string
}

export type PaymentTransaction = {
  id: string
  type: 'PAYMENT'
  createdOn: moment.Moment
  description?: string
  amount: number
}

export type IntervalInterestTransaction = {
  id: string
  type: 'INTERVAL_INTEREST'
  createdOn: moment.Moment
  interval: number
}

export type Transaction =
  | InitTransaction
  | CloseTransaction
  | PaymentTransaction
  | IntervalInterestTransaction

export type TransactionState = {
  amount: number
  interest: number
  latestUpdate: moment.Moment | null
  loanedAmount: number
  closedOn: moment.Moment | null
  createdOn: moment.Moment | null
}

export enum LoanType {
  CLASSIC,
  INTERVAL
}


// WEBPACK FOOTER //
// ./src/utils/transactions/types.tsx